import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Assessment, AssessmentSearch } from '../models/assessment';
import { SubdomainService } from './subdomain.service';

@Injectable({
  providedIn: 'root',
})
export class AssessmentService {
  private isSharedAssesment: boolean = false;
  private baseURL = `${environment.apiBaseUrl}/api/assessment/`;
  constructor(
    private httpClient: HttpClient,
    private subdomainService: SubdomainService
  ) {}

  public get sharedAssesment() {
    return this.isSharedAssesment;
  }

  public set sharedAssesment(isShared: boolean) {
    this.isSharedAssesment = isShared;
  }

  doLoad = (paramObject?: any, location?: any): Observable<any> => {
    let queryParams: string;
    let url = `${this.baseURL}${location}`;
    if (paramObject) {
      queryParams = new URLSearchParams(paramObject).toString();
      url = `${url}?${queryParams}`;
    }
    return this.httpClient.get<any>(url);
  };

  doPost = (paramObject: any, body: any, location: string): Observable<any> => {
    let queryParams: string;
    let url = `${this.baseURL}${location}`;
    if (paramObject) {
      queryParams = new URLSearchParams(paramObject).toString();
      url = `${url}?${queryParams}`;
    }
    return this.httpClient.post<any>(url, body);
  };

  doPut = (paramObject: any, body: any, location: string): Observable<any> => {
    let queryParams: string;
    let url = `${this.baseURL}${location}`;
    if (paramObject) {
      queryParams = new URLSearchParams(paramObject).toString();
      url = `${url}?${queryParams}`;
    }
    return this.httpClient.put<any>(url, body);
  };

  createAssesment = (assesment: Assessment): Observable<any> => {
    assesment.subdomain = this.subdomainService.getSubdomain();
    return this.doPost({}, assesment, 'create');
  };

  updateAssesment = (assesment: Assessment): Observable<any> => {
    assesment.subdomain = this.subdomainService.getSubdomain();
    return this.doPut({}, assesment, 'update');
  };

  getSingleAssesment = (assesmentId: number) => {
    return this.httpClient.get<any>(`${this.baseURL}getSingle/${assesmentId}`);
  };
  getSingleAssessmentByUUID = (qr_code: string) => {
    return this.doPost({}, { qr_code }, 'getSingleByUUID');
  };
  createMultipleAssesment = (assesment: Assessment[]): Observable<any> => {
    assesment.forEach((data) => {
      data.subdomain = this.subdomainService.getSubdomain();
    });
    return this.doPost({}, assesment, 'createMultiple');
  };

  getAllAssesmentList = () => {
    return this.doPost(
      {},
      { subdomain: this.subdomainService.getSubdomain() },
      'getAll'
    );
  };

  deleteAssesment = (assesmentId: number): Observable<any> => {
    return this.httpClient.delete<any>(`${this.baseURL}delete/${assesmentId}`);
  };
  getAssessmentList = (is_sort_by_holding_number: boolean) => {
    return this.doPost(
      {},
      {
        subdomain: this.subdomainService.getSubdomain(),
        is_sort_by_holding_number: is_sort_by_holding_number,
      },
      'search'
    );
  };
  getFilteredAssessmentList = (
    assessmentSearch: AssessmentSearch,
    is_sort_by_holding_number: boolean
  ) => {
    return this.doPost(
      {},
      {
        subdomain: this.subdomainService.getSubdomain(),
        holding_number: assessmentSearch.holding_number,
        ward_number: assessmentSearch.ward_number,
        serial_no_start: assessmentSearch.serial_no_start,
        serial_no_end: assessmentSearch.serial_no_end,
        gram_or_rasta: assessmentSearch.gram_or_rasta,
        is_sort_by_holding_number: is_sort_by_holding_number,
      },
      'search'
    );
  };
}
